import { IS_DEV } from '@/helpers/env'
import { europeanCountries } from '@/helpers/language'
import { api } from '@/utils/api'


import { useMemo } from 'react';
// 判断用户是否在欧洲地区
export function useReqInfo() {
  const { data, isInitialLoading } = api.user.getReqInfo.useQuery()

  const inEuropean = useMemo(() => {
    if (IS_DEV) {
      return true
    }
    if (typeof data === 'undefined' || data?.country === null) {
      return false
    } else {
      return europeanCountries.includes(data.country)
    }
  }, [data])
  return { inEuropean, isInitialLoading }
}
